import React from "react";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";

const XLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40px"
    height="40px"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z" />
  </svg>
);

const SocialMediaIcons = () => {
  return (
    <SocialIconContainer>
      <SocialIcon
        href="https://www.facebook.com/HabitatBuffalo"
        target="_blank"
        aria-label="Facebook"
      >
        <LazyLoad height={40} offset={100}>
          <FaFacebook size={40} className="icon-image" />
        </LazyLoad>
      </SocialIcon>
      <SocialIcon
        href="https://www.instagram.com/HabitatBuffalo"
        target="_blank"
        aria-label="Instagram"
      >
        <LazyLoad height={40} offset={100}>
          <FaInstagram size={40} className="icon-image" />
        </LazyLoad>
      </SocialIcon>
      <SocialIcon
        href="https://www.linkedin.com/company/habitat-for-humanity-buffalo"
        target="_blank"
        aria-label="LinkedIn"
      >
        <LazyLoad height={40} offset={100}>
          <FaLinkedin size={40} className="icon-image" />
        </LazyLoad>
      </SocialIcon>
      <SocialIcon
        href="https://www.x.com/HabitatBuffalo" // Replace with the correct X link
        target="_blank"
        aria-label="X"
      >
        <LazyLoad height={40} offset={100}>
          <XLogo />
        </LazyLoad>
      </SocialIcon>
      <SocialIcon
        href="https://www.youtube.com/user/HabitatBuffalo"
        target="_blank"
        aria-label="YouTube"
      >
        <LazyLoad height={40} offset={100}>
          <FaYoutube size={40} className="icon-image" />
        </LazyLoad>
      </SocialIcon>
    </SocialIconContainer>
  );
};

const SocialIconContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const SocialIcon = styled.a`
  color: inherit;
  &:hover {
    color: var(--primary-color);
  }
`;

export default SocialMediaIcons;
